export default __webpack_public_path__ + "static/media/brand1.10d9dc6b.webp";